import { DiscountType } from '@trnsact/trnsact-shared-types';
import { MoneyService, moneyService } from 'shared';

import { QuoteEquipmentWithCharge } from '../types';

class EquipmentCalc {
  constructor(private readonly money: MoneyService = moneyService) {}

  private toPercent(amount: number) {
    return amount / 100;
  }

  public calcRetailPrice(charge: QuoteEquipmentWithCharge) {
    const {
      price: { wholesalePrice, markup, markupType, retailPrice },
    } = charge;

    if (markupType === DiscountType.Flat) return this.money.roundToCents(wholesalePrice + markup) || retailPrice;
    if (markupType === DiscountType.Percent)
      return this.money.roundToCents(wholesalePrice + wholesalePrice * this.toPercent(markup)) || retailPrice;

    throw new Error('Unrecognized value for charge.');
  }
}

export const equipmentCalc = new EquipmentCalc();
